"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.maxCookieExpirationMins = void 0;
exports.getCookieFromString = getCookieFromString;
exports.createCookieString = createCookieString;
exports.getCookie = getCookie;
exports.setCookie = setCookie;
// ref https://www.w3schools.com/js/js_cookies.asp
const time_1 = require("./time");
/**
 * Gets the value from a cookie string
 * @param cookieString
 * @param cname
 * @returns
 */
function getCookieFromString(cookieString, cname) {
    const name = cname + '=';
    const decodedCookie = decodeURIComponent(cookieString);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
}
/**
 * Creates a string to set the value and expiration of a cookie
 * @param cname
 * @param cvalue
 * @param exmins
 */
function createCookieString(cname, cvalue, exmins) {
    const d = new Date();
    d.setTime(d.getTime() + exmins * time_1.MINUTE_MS);
    const expires = 'expires=' + d.toUTCString();
    return cname + '=' + cvalue + ';' + expires + ';path=/';
}
// ref https://www.w3schools.com/js/js_cookies.asp
/**
 * Gets the value of a cookie
 * @param cname
 * @returns
 */
function getCookie(cname) {
    return getCookieFromString(document.cookie, cname);
}
/**
 * Sets the value and expiration of a cookie
 * @param cname
 * @param cvalue
 * @param exmins
 */
function setCookie(cname, cvalue, exmins) {
    document.cookie = createCookieString(cname, cvalue, exmins);
}
/* Cookies have a maximum expiration of 400 days */
exports.maxCookieExpirationMins = 399 * time_1.DAY_MINS;
//# sourceMappingURL=cookies.js.map